module.exports = __webpack_public_path__ + "static/media/DefaultProfile.55dc5c78.svg";